import { render, staticRenderFns } from "./AddMemberModal.vue?vue&type=template&id=8b4d078a&scoped=true&"
import script from "./AddMemberModal.vue?vue&type=script&lang=js&"
export * from "./AddMemberModal.vue?vue&type=script&lang=js&"
import style0 from "./AddMemberModal.vue?vue&type=style&index=0&id=8b4d078a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4d078a",
  null
  
)

export default component.exports